var map = {
	"./afDetected.svg": 1170,
	"./afNotDetected.svg": 256,
	"./blood_pressure.svg": 1171,
	"./bt.svg": 257,
	"./calories.svg": 371,
	"./heart_rate.svg": 1172,
	"./medcine_reminder.svg": 370,
	"./night_respiratory.svg": 372,
	"./night_rsi.svg": 373,
	"./notMeasured.svg": 1173,
	"./pointer.svg": 258,
	"./print.svg": 538,
	"./respiratory_rate.svg": 1174,
	"./sleep.svg": 374,
	"./spo2.svg": 1175,
	"./steps.svg": 375,
	"./watch.svg": 259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;